import { createSlice } from "@reduxjs/toolkit";
import { PARAMS } from "../util/GlobalConstants";

const themeSlice = createSlice({
  name: "theme",
  initialState: { currentTheme: PARAMS.theme.cobalt },
  reducers: {
    change(state, action) {
      state.currentTheme = action.payload;
      document.body.setAttribute("class", action.payload);
    },
  },
});

export const themeActions = themeSlice.actions;

export default themeSlice;
